import { useState, useEffect } from 'react';

/**
 * Debounce a value by the specified delay.
 * Returns the debounced value that updates after the delay has passed.
 *
 * @param value The value to debounce
 * @param delay The debounce delay in milliseconds (default: 300ms)
 * @returns The debounced value
 */
export function useDebouncedValue<T>(value: T, delay = 300): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
}
